export default __webpack_public_path__ + "6aaebc6c942cc7eda3bb69bf8db52cf6.svg";